// extracted by mini-css-extract-plugin
export default {"root":"SellectAllCellRenderer_root__V1523","checkbox":"SellectAllCellRenderer_checkbox__mgdME"};